import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import {
  IconCheck,
  IconEdit,
  IconEyeOff,
  IconTagStarred,
  IconTrash,
} from "@tabler/icons-react";

const ItemStatus = ({ id }: { id: string }) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return "...";
  if (isError) return <ErrMessage message={isError} />;
  switch (item.status) {
    case "active":
      return (
        <>
          <IconCheck /> Aktiv
        </>
      );
    case "reserved":
      return (
        <>
          <IconTagStarred /> Reserviert
        </>
      );
    case "hidden":
      return (
        <>
          <IconEyeOff /> Nicht gelistet
        </>
      );
    case "deleted":
      return (
        <>
          <IconTrash /> Gelöscht
        </>
      );
    case "draft":
      return (
        <>
          <IconEdit /> Entwurf
        </>
      );
    default:
      return item.status;
  }
};
export default ItemStatus;
